import { ServModel } from '../models/serv.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { CustomerService } from './customer.service';
import { Estate } from '../utils/enum.util';
import { MagasinService } from './magasin.service';
import { Router } from '@angular/router';
import { BikeService2 } from './bike2.service';

@Injectable()
export class ServService {

    private antiRebound = 300;
    private timestamp   = 0;

    current              = null;
    currentState: Estate = Estate.Save;

    listOver: ServModel[]       = [];
    listInProgress: ServModel[] = [];
    isOpen: boolean             = false;

    constructor(public router: Router, public apiService: ApiService, public customerService: CustomerService, public magasinService: MagasinService, public bikeService:BikeService2) {

    }

    loadAll() {
        this.apiService.get('services', '').subscribe(res=> {
            if (this.listOver.length)
                this.listOver.length = 0;
            if (this.listInProgress.length)
                this.listInProgress.length = 0;
            let serv: ServModel;
            res.data.forEach((s)=> {
                serv                 = new ServModel(this);
                serv.privateId       = s._id;
                serv.about           = s.about;
                serv.clientPrivateId = s.clientPrivateId;
                serv.client          = s.client;
                serv.publicId        = s.publicId;
                serv.process         = s.state;
                serv.created         = new Date(s.created);
                serv.whenContacted   = s.whenContacted;
                serv.whenOver        = new Date(s.whenOver);
                serv.whenRestitute   = s.whenRestitute;

                if (s.price == 0)
                    serv.price = null;
                else
                    serv.price = s.price;

                if (s.state == 'over') {
                    this.listOver.push(serv)
                } else if (s.state == 'inProgress') {
                    this.listInProgress.push(serv);
                } else {
                    console.error('Service not pushed in list', serv);
                }
                //trie des terminer par date de over
                for (let i = 0; i < this.listOver.length - 1; i++) {
                    if (this.listOver[i].whenOver < this.listOver[i + 1].whenOver) {
                        let tmp              = this.listOver[i];
                        this.listOver[i]     = this.listOver[i + 1];
                        this.listOver[i + 1] = tmp;
                        i                    = 0;
                    }
                }
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    get(id: string) {
        this.apiService.get('service', 'privateId=' + id).subscribe((_res)=> {
            this.current = ServModel.j2o(_res.data, this);
            this.bikeService.list = [];
            this.bikeService.getAll(this.current.client.id);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    create(clientPrivateId: string) {
        this.apiService.post('service', {
            'clientPrivateId': clientPrivateId,
            'magasin'        : this.magasinService.current
        }).subscribe((_res)=> {
            this.bikeService.list = [];
            this.bikeService.getAll(clientPrivateId);
            this.customerService.tabActive = 'Résumé';
            this.current                   = ServModel.j2o(_res.data, this);
            //update resume
            this.customerService.resume.notRestituteServices++;
            this.customerService.resume.nbrServices++;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    update(service: ServModel) {
        let data;

        data = ServModel.o2j(service);

        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('service', data).subscribe((_res)=> {
                    if (this.current) {
                        if (!this.current.errors)
                            service.state = Estate.Save;
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                    service.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    delete(service: ServModel) {
        this.apiService.delete('service', {'privateId': service.privateId}).subscribe((_res)=> {
            this.router.navigate(['/tasks']);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    updateField(service: ServModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();

        setTimeout(()=> {
            let data = {
                'privateId': service.privateId,
                'about'    : service.about,
                'price'    : 0
            };
            if (service.price)
                data.price = service.price;
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('service', data).subscribe((_res)=> {
                    //update activities
                    if (service.clientPrivateId == this.customerService.activities.privateId) {
                        for (let i = 0; i < this.customerService.activities.data.length; i++) {
                            if (this.customerService.activities.data[i].type && this.customerService.activities.data[i].type == 'Service' && this.customerService.activities.data[i]._id == service.privateId) {
                                this.customerService.activities.data[i].price = service.price;
                                this.customerService.activities.data[i].about = service.about.toString();
                            }
                        }
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                });
            }
        }, this.antiRebound);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/serv.service.ts